"use client";

import { useEffect, useState } from "react";
import StatsCard from "@/components/ui/StatsCard";
import type { ShieldedPoolMetric } from "@/app/api/shielded-pools/route";

export default function ShieldedPoolStats(): React.ReactElement {
  const [metrics, setMetrics] = useState<ShieldedPoolMetric[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchMetrics() {
      try {
        const res = await fetch("/api/shielded-pools");
        if (!res.ok) throw new Error("Failed to fetch shielded pool data");
        const json: ShieldedPoolMetric[] = await res.json();
        setMetrics(json);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Unknown error");
      } finally {
        setIsLoading(false);
      }
    }
    fetchMetrics();
  }, []);

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-[30px]">
        {Array.from({ length: 4 }).map((_, i) => (
          <StatsCard key={i} label="" value="" isLoading />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-[90px] border border-foreground/5 max-sm:border-foreground/10 bg-foreground/2">
        <span className="text-accent-red text-[13px] font-kode-mono">{error}</span>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-[30px]">
      {metrics.map((stat) => (
        <StatsCard
          key={stat.id}
          label={stat.label}
          value={stat.value}
          percentageChange={stat.percentageChange}
          isPositive={stat.isPositive}
        />
      ))}
    </div>
  );
}
